const GOLD = "oklch(0.85 0.28 85)"
const NEON_GREEN = "oklch(0.8 0.3 145)"

interface NeonTraceTitleProps {
  id: string
  text: string
  viewBox: string
  fontSize: number
  letterSpacing: number
  glowBlur: number
  textGlowBlur: number
  goldStrokeWidth: number
  greenStrokeWidth: number
  ariaLabel: string
  goldAnimDuration?: number
  greenAnimDuration?: number
}

export function NeonTraceTitle({
  id,
  text,
  viewBox,
  fontSize,
  letterSpacing,
  glowBlur,
  textGlowBlur,
  goldStrokeWidth,
  greenStrokeWidth,
  ariaLabel,
  goldAnimDuration = 18,
  greenAnimDuration = 24,
}: NeonTraceTitleProps) {
  const [, , w, h] = viewBox.split(" ").map(Number)
  const cx = w / 2
  const cy = h / 2

  return (
    <svg viewBox={viewBox} className="w-full" aria-label={ariaLabel} role="img">
      <style>{`
        .${id}-trace-gold {
          animation: ${id}-trace ${goldAnimDuration}s linear infinite;
        }
        .${id}-trace-green {
          animation: ${id}-trace ${greenAnimDuration}s linear infinite reverse;
        }
        @keyframes ${id}-trace {
          to { stroke-dashoffset: -300; }
        }
      `}</style>
      <defs>
        <filter id={`${id}-glow`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur
            in="SourceGraphic"
            stdDeviation={glowBlur}
            result="blur"
          />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter
          id={`${id}-text-glow`}
          x="-10%"
          y="-10%"
          width="120%"
          height="130%"
        >
          <feGaussianBlur
            in="SourceGraphic"
            stdDeviation={textGlowBlur}
            result="glow"
          />
          <feMerge>
            <feMergeNode in="glow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <text
          id={`${id}-text`}
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily="'Chakra Petch', sans-serif"
          fontWeight="700"
          fontSize={fontSize}
          letterSpacing={letterSpacing}
        >
          {text}
        </text>

        <mask id={`${id}-exterior-mask`}>
          <rect x="0" y="0" width={w} height={h} fill="white" />
          <use
            href={`#${id}-text`}
            fill="black"
            stroke="black"
            strokeWidth="8"
          />
        </mask>
      </defs>

      <use href={`#${id}-text`} fill={GOLD} filter={`url(#${id}-text-glow)`} />

      <g filter={`url(#${id}-glow)`}>
        <g mask={`url(#${id}-exterior-mask)`}>
          <use
            href={`#${id}-text`}
            fill="none"
            stroke={GOLD}
            strokeWidth={goldStrokeWidth}
            strokeDasharray="50 35 20 45"
            strokeLinecap="square"
            className={`${id}-trace-gold`}
          />
          <use
            href={`#${id}-text`}
            fill="none"
            stroke={NEON_GREEN}
            strokeWidth={greenStrokeWidth}
            strokeDasharray="30 60 15 40"
            strokeDashoffset={50}
            strokeLinecap="square"
            className={`${id}-trace-green`}
          />
        </g>
      </g>
    </svg>
  )
}
